export enum BuildingKindEnum {
	ONE_TWO_FAMILY = 'Ein- oder Zweifamilienhause',
	MORE_FAMILY = 'Mehrfamilienhaus',
	ROW_HOUSE = 'Reihenhaus',
}
